import './types';
import { endpoints } from '../api/endpoints';
import { useAuth } from '../store/auth';
import { waitForTelegramInitData } from './detect';

/**
 * Обменивает Telegram init-data на нашу сессию и кладёт её в auth-стор.
 * true — вошли; false — не Telegram / initData не пришёл за таймаут / обмен не удался.
 * НЕ сдаёмся на первом чтении initData — ждём, пока Telegram его наполнит (холодный запуск).
 */
export async function bootstrapTelegram(): Promise<boolean> {
  const initData = await waitForTelegramInitData();
  if (!initData) return false;
  try {
    window.Telegram?.WebApp?.ready();
  } catch {
    // ready() необязателен для обмена — игнорируем сбой SDK.
  }
  try {
    const session = await endpoints.loginWithTelegram(initData);
    // consentRequired из ответа → новый Telegram-юзер сразу попадёт на ConsentScreen в Protected.
    useAuth.getState().setSession({
      accessToken: session.accessToken,
      refreshToken: session.refreshToken,
      user: session.user,
      consentRequired: session.consentRequired,
    });
    return true;
  } catch {
    return false;
  }
}
